<template>
  <div class="container">
    <ListPanel :recipient-id="owner.data.id" :recipient-type="owner.data.type"/>
  </div>
</template>

<script>
import ListPanel from "@/components/Bookkeeping/Invoices/Panels/List";

export default {
  components: {ListPanel},

  model: {
    prop: 'owner',
    event: 'owner-updated'
  },

  props: ['owner'],
}
</script>
